"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformProvidersForDisplay = void 0;
/**
 * Transforms provider result data for display in MiniProviderCardList
 * This function is shared between AltProviders and CareTeamsProviders components
 * to avoid code duplication.
 *
 * @param {Array} providers - Array of provider result objects
 * @param {Object} config - Configuration object
 * @returns {Array} Transformed provider data for MiniProviderCardList
 */
function transformProvidersForDisplay(providers, config) {
    if (!providers || !Array.isArray(providers)) {
        return [];
    }
    return providers.map((providerResult) => {
        return {
            availability: providerResult.availability || {},
            config,
            location: (providerResult.locations && providerResult.locations[0]) || {},
            provider: providerResult.provider || {
                id: 'unknown',
                name: { full_name: 'Unknown Provider' }
            }
        };
    });
}
exports.transformProvidersForDisplay = transformProvidersForDisplay;
//# sourceMappingURL=utils.js.map